var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { useLayoutEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { getTargetElement } from '../utils/dom';
import useRafState from './useRafState';

function useSize(target) {
  var _a = __read(useRafState(function () {
    var el = getTargetElement(target);
    return {
      width: (el || {}).clientWidth,
      height: (el || {}).clientHeight
    };
  }), 2),
      state = _a[0],
      setState = _a[1];

  useLayoutEffect(function () {
    var el = getTargetElement(target);

    if (!el) {
      return function () {};
    }

    var resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        setState({
          width: entry.target.clientWidth,
          height: entry.target.clientHeight
        });
      });
    });
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
    };
  }, [target]);
  return state;
}

export default useSize;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useSize/index.js
// module id = 956
// module chunks = 2